import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AskServerService } from '../ask-server.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-confirm-table',
  templateUrl: './confirm-table.component.html',
  styleUrls: ['./confirm-table.component.scss']
})
export class ConfirmTableComponent implements OnInit {
  changeTableForm = new FormGroup({
    idNew: new FormControl('', [
      Validators.required,
      Validators.max(20),
      Validators.min(1),
      Validators.pattern('^[0-9]*$')
    ])
  });

  idTable: string;
  tid: string;
  //idNew :string;

  get idNew() {
    return this.changeTableForm.get('idNew');
  }

  constructor(
    private askServer: AskServerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected $gaService: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    const type = localStorage.getItem('calltype');
    this.idTable = this.activatedRoute.snapshot.paramMap.get('id');
    // this.idTable = '17';
    this.tid = 'Table nº ' + this.idTable;

    this.askServer.ouvertureTable(this.idTable,type);
    this.$gaService.event('Appel', 'Serveur', type);
    localStorage.setItem('showModal', 'true');
    this.router.navigate(['/carte/table/' + this.idTable]);
  }

  public appelServeur() {
    this.askServer.editTable({
      idNew: this.changeTableForm.value.idNew,
      idTable: this.idTable
    });
    //this.askServer.appelServeur(this.changeTableForm.value.idNew);
    this.router.navigate(['/carte/' + this.changeTableForm.value.idNew]);
  }

  public openTheTable(tableId) {
    const type = localStorage.getItem('calltype');
    localStorage.setItem('showModal', 'true');
    this.askServer.ouvertureTable(tableId, type);
    this.router.navigate(['/carte/table/' + tableId]);
  }
}
